
import React from 'react';



type Props = {
  className?: string;
}
export const ServiceEnginePortalVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <g clipPath = 'url(#clip0_1843_14891)'>
        <path fill = 'white' d = 'M9.992 2.5C5.576 2.5 2 6.084 2 10.5C2 14.916 5.576 18.5 9.992 18.5C14.416 18.5 18 14.916 18 10.5C18 6.084 14.416 2.5 9.992 2.5ZM15.536 7.3H13.176C12.92 6.3 12.552 5.34 12.072 4.452C13.544 4.956 14.768 5.98 15.536 7.3ZM10 4.132C10.664 5.092 11.184 6.156 11.528 7.3H8.472C8.816 6.156 9.336 5.092 10 4.132ZM3.808 12.1C3.68 11.588 3.6 11.052 3.6 10.5C3.6 9.948 3.68 9.412 3.808 8.9H6.512C6.448 9.428 6.4 9.956 6.4 10.5C6.4 11.044 6.448 11.572 6.512 12.1H3.808ZM4.464 13.7H6.824C7.08 14.7 7.448 15.66 7.928 16.548C6.456 16.044 5.232 15.028 4.464 13.7ZM6.824 7.3H4.464C5.232 5.972 6.456 4.956 7.928 4.452C7.448 5.34 7.08 6.3 6.824 7.3ZM10 16.868C9.336 15.908 8.816 14.844 8.472 13.7H11.528C11.184 14.844 10.664 15.908 10 16.868ZM11.872 12.1H8.128C8.056 11.572 8 11.044 8 10.5C8 9.956 8.056 9.42 8.128 8.9H11.872C11.944 9.42 12 9.956 12 10.5C12 11.044 11.944 11.572 11.872 12.1ZM12.072 16.548C12.552 15.66 12.92 14.7 13.176 13.7H15.536C14.768 15.02 13.544 16.044 12.072 16.548ZM13.488 12.1C13.552 11.572 13.6 11.044 13.6 10.5C13.6 9.956 13.552 9.428 13.488 8.9H16.192C16.32 9.412 16.4 9.948 16.4 10.5C16.4 11.052 16.32 11.588 16.192 12.1H13.488Z' />
      </g>
      <defs>
        <clipPath id = 'clip0_1843_14891'>
          <rect width = '20' height = '20' fill = 'white'/>
        </clipPath>
      </defs>
    </svg>
  );
};
